module.exports = __webpack_public_path__ + "static/media/link.2ab40b0b.svg";